import { INhomCauHoiRequest } from "../../../model/request/nhom-cau-hoi/INhomCauHoiRequest";
import { ISMT_NhomCauHoi } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi";
import { ISMT_NhomCauHoi_Vm } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi_Vm";
import { INhomCauHoiActionTypes } from "../../action-types/cau-hoi/INhomCauHoiActions";
import { INhomCauHoiReducer } from "../../reducer-model/cau-hoi/INhomCauHoiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: INhomCauHoiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  nhomCauHois: [],
  nhomCauHoiEditing: {} as ISMT_NhomCauHoi_Vm,
  idSelections: [],
  searchNhomCauHoiById: {} as ISMT_NhomCauHoi,
  isShowProgressModal: false,
  idProgress: [],
  pageIndex: 0,
  request: {
    id_bm: 0,
    id_he: 0,
    id_mon: 0,
  } as INhomCauHoiRequest,
};

export const nhomCauHoiReducer = (
  state: INhomCauHoiReducer = iniState,
  action: INhomCauHoiActionTypes
): INhomCauHoiReducer => {
  switch (action.type) {
    case "NHOM_CAU_HOI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nhomCauHois: [],
      };
    case "NHOM_CAU_HOI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nhomCauHois: action.payload,
      };
    case "NHOM_CAU_HOI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_CAU_HOI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_CAU_HOI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "NHOM_CAU_HOI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_CAU_HOI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NHOM_CAU_HOI_DELETE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "NHOM_CAU_HOI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_CAU_HOI_SHOW_EDIT_MODAL":
      return {
        ...state,
        nhomCauHoiEditing: action.payload,
        isShowEditModal: true,
      };
    case "NHOM_CAU_HOI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        nhomCauHoiEditing: undefined,
        isShowEditModal: false,
      };
    case "NHOM_CAU_HOI_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "NHOM_CAU_HOI_LOAD_BY_ID_SUCCESS":
      return {
        ...state,
        nhomCauHois: [
          ...state.nhomCauHois.filter((x) => x.id !== action.payload.id),
          action.payload,
        ],
      };
    case "NHOM_CAU_HOI_IMPORT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_CAU_HOI_IMPORT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowImportModal: false,
      };
    case "NHOM_CAU_HOI_IMPORT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "NHOM_CAU_HOI_IMPORT_OPEN_MODAL":
      return {
        ...state,
        isShowImportModal: true,
      };
    case "NHOM_CAU_HOI_IMPORT_CLOSE_MODAL":
      return {
        ...state,
        isShowImportModal: false,
      };

    case "NHOM_CAU_HOI_SHOW_ADD_MUCTRINANG_MODAL":
      return {
        ...state,
        nhomCauHoiAddMucTriNang: action.payload,
      };
    case "NHOM_CAU_HOI_CLOSE_ADD_MUCTRINANG_MODAL":
      return {
        ...state,
        nhomCauHoiAddMucTriNang: undefined,
      };
    case "NHOM_CAU_HOI_SAVE_MUCTRINANG_SUCCESS":
      return {
        ...state,
        nhomCauHoiAddMucTriNang: undefined,
        status: eReducerStatusBase.is_need_reload,
      };
    // case "NHOM_CAU_HOI_SEARCH_BY_NHOM_CAU_HOI_ID_START":
    //   return {
    //     ...state,
    //     status: eReducerStatusBase.is_loading,
    //   };
    // case "NHOM_CAU_HOI_SEARCH_BY_NHOM_CAU_HOI_ID_SUCCESS":
    //   return {
    //     ...state,
    //     status: eReducerStatusBase.is_completed,
    //     searchNhomCauHoiById: action.payload,
    //   };
    // case "NHOM_CAU_HOI_SEARCH_BY_NHOM_CAU_HOI_ID_ERROR":
    //   return {
    //     ...state,
    //     status: eReducerStatusBase.is_completed,
    //   };
    case "NHOM_CAU_HOI_DELETE_BO_CAU_HOI_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NHOM_CAU_HOI_DELETE_BO_CAU_HOI_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "NHOM_CAU_HOI_DELETE_BO_CAU_HOI_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_CAU_HOI_SHOW_PROGRESS_MODAL":
      return {
        ...state,
        isShowProgressModal: true,
        idProgress: action.payload,
      };
    case "NHOM_CAU_HOI_CLOSE_PROGRESS_MODAL":
      return {
        ...state,
        isShowProgressModal: false,
      };
    case "NHOM_CAU_HOI_PROGRESS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_CAU_HOI_PROGRESS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowProgressModal: false,
        idSelections: [],
        idProgress: [],
      };
    case "NHOM_CAU_HOI_PROGRESS_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_CAU_HOI_CHANGE_REQUEST":
      return {
        ...state,
        pageIndex: 0,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    case "NHOM_CAU_HOI_SYNC_VNPT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_CAU_HOI_SYNC_VNPT_SUCCESS":
    case "NHOM_CAU_HOI_SYNC_VNPT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_CAU_HOI_SYNC_KHONG_SU_DUNG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_CAU_HOI_SYNC_KHONG_SU_DUNG_SUCCESS":
    case "NHOM_CAU_HOI_SYNC_KHONG_SU_DUNG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
